import React from 'react'

const HowToUse = () => {
  return (
    <div className='p-4'>
        How to use will be implemented soon!!....
    </div>
  )
}

export default HowToUse